import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Header } from '../components/layout/Header';
export function ThankYou() {
  return <div className="flex min-h-screen w-full flex-col bg-brand-charcoal" data-id="element-127" data-mp="2jrpzvfhc7v72">
      <Header logoHref={null} showActions={false} data-id="element-128" data-mp="2jtsygnwk2wne" />

      <main className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center sm:px-6 lg:px-8" data-id="element-129" data-mp="2or2rsen2fsgi">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-teal" data-id="element-130" data-mp="2tp4c12w89xtk">
          <CheckIcon className="h-7 w-7 text-white" aria-hidden="true" data-id="element-131" data-mp="3ch6oe21u6ry0" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-8 max-w-3xl" data-id="element-132" data-mp="3heoyvwvi5f84">
          <h1 className="font-display text-4xl leading-tight text-white sm:text-5xl" data-id="element-133" data-mp="1y9sw6qhlia43">Thank You</h1>
          <p className="mt-4 text-lg leading-relaxed text-white/80 sm:text-xl" data-id="element-134" data-mp="1u87nzig0ak08">
            We've Received Your Request
          </p>
        </motion.div>
      </main>
    </div>;
}